import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((_theme) => ({
  iconColumn: {
    width: 150,
  },

  icon: {
    margin: '0 8px',
  },

  newUsersIcon: {
    fontSize: 20,
    marginLeft: 15,
    verticalAlign: 'middle',
  },
}));

export default useStyles;
